import React, { Component } from "react";
import "./App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import LoginBrandPage from "./brand_components/login/viewChanger";
import ForgotPassword from "./brand_components/forgotpassword/viewChanger";
import LeafLibrary from "./brand_components/dashboard/leaf-library";
import { Router } from "react-router-dom";
import history from "./services/history";
import { Switch, Route } from "react-router-dom";
import HomeScreen from "./brand_components/home/viewChanger";
import SignUp from "./brand_components/signup/viewChanger";
import About from "./brand_components/about/about";
import Contact from "./brand_components/about/viewChanger";
import Policy from "./brand_components/about/privacy_and_terms";
import Dashboard from "./brand_components/dashboard/about_brand";
import Product from "./brand_components/dashboard/product";
import CompanyInfo from "./brand_components/dashboard/company_info";
import Subscription from "./brand_components/dashboard/subscription";
import MainPage from "./MainPage";

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    backgroundColor: "white",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
});

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Router history={history}>
          <Switch>
            <Route exact path="/" component={HomeScreen} />
            <Route exact path="/about" component={About} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/policy" component={Policy} />
            <Route exact path="/login" component={LoginBrandPage} />
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/join" component={SignUp} />
            <Route
              exact
              path="/company/leaflibrary"
              component={LeafLibrary}
              isPrivate
            />
            <Route
              exact
              path="/company/aboutbrand"
              component={Dashboard}
              isPrivate
            />
            <Route
              exact
              path="/company/product"
              component={Product}
              isPrivate
            />
            <Route
              exact
              path="/company/companyinfo"
              component={CompanyInfo}
              isPrivate
            />
            <Route
              exact
              path="/company/subscription"
              component={Subscription}
              isPrivate
            />
            <Route path="/admin" component={MainPage} isPrivate />
          </Switch>
        </Router>
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);
